import {ComponentRegistry} from '../../components/component-registry';
import {DataApi} from '../../api/data-api/data-api';
import {AbstractFilter} from '../abstract-filter';
import {Filter, NewsFilter, NewsSettings} from './filter';
import {AbstractPaginatedList} from '../abstract-paginated-list';

/**
 * News list.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export class List extends AbstractPaginatedList<NewsFilter, NewsSettings> {
  constructor(container: HTMLElement) {
    super(container);

    ComponentRegistry.wait<Filter>('news-filter')
      .then(filterPlugin => {
        this.find(filterPlugin.filter);
        filterPlugin.emitter.on('change', () => {
          this.pagination.browse(0);
        });
        this.pagination.emitter.on('browse', paginationSettings => {
          this.settings.start = paginationSettings.start;
          this.find(filterPlugin.filter);
        });
      });

    ComponentRegistry.add('news-list', this);
  }

  /**
   * Finds newss.
   *
   * @param {NewsFilter} filter Filter
   */
  protected find(filter: NewsFilter | null): void {
    filter = AbstractFilter.isFilterEmpty<NewsFilter>(filter) ? null : filter;
    DataApi.instance.newsEndpoint.find(this.settings, filter)
      .then(response => {
        if (this.isResultEmpty(response)) {
          this.empty();
          return;
        }
        this.notEmpty();

        let html = '';
        let i = 0;
        for (const document of response.documents) {
          const template = require('../../handlebars/templates/news/item.handlebars');
          html += template({
            document: document,
            isLast: i === response.documents.length - 1,
            iteration: i++
          });
        }
        this.update(html);

        this.pagination.settings.numFound = response.numFound;
        this.pagination.update();

        this.emitter.emit('change', this);
      })
      .catch(e => {
        this.error(e);
      });
  }
}
